import { render, staticRenderFns } from "./Drivers.vue?vue&type=template&id=1f287715&scoped=true&"
import script from "./Drivers.vue?vue&type=script&lang=js&"
export * from "./Drivers.vue?vue&type=script&lang=js&"
import style0 from "./Drivers.vue?vue&type=style&index=0&id=1f287715&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f287715",
  null
  
)

export default component.exports